const SOUND_URL = (process.env.PUBLIC_URL || '') + '/soundreality-pop-sound-423716.mp3';

let cachedAudio = null;
let userHasInteracted = false;

function getAudio() {
  if (!cachedAudio) {
    cachedAudio = new Audio(SOUND_URL);
    cachedAudio.volume = 0.6;
    cachedAudio.preload = 'auto';
  }
  return cachedAudio;
}

// Browsers block audio playback until the user has interacted with the page.
// Pre-load the audio element on first user interaction so it's ready to play.
if (typeof window !== 'undefined') {
  const onInteraction = () => {
    userHasInteracted = true;
    const a = getAudio();
    // Force the browser to load/unlock the audio element
    a.load();
  };
  ['click', 'touchstart', 'keydown'].forEach(evt =>
    document.addEventListener(evt, onInteraction, { capture: true, once: true })
  );
}

export function playNotificationSound() {
  try {
    const audio = getAudio();
    // Reset to start so rapid successive calls still produce sound
    audio.currentTime = 0;
    const p = audio.play();
    if (p && typeof p.catch === 'function') {
      p.catch(() => {
        // Fallback: create a fresh Audio element (handles edge cases where
        // the cached element got into a bad state)
        try {
          const fallback = new Audio(SOUND_URL);
          fallback.volume = 0.6;
          fallback.play().catch(() => {});
        } catch {}
      });
    }
  } catch {
    // Audio API not available in this environment
  }
}
